import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IListEvidenceState, LIST_EVIDENCE_STORE_KEY } from './list-evidence-store.state';

const state = createFeatureSelector<IListEvidenceState>(LIST_EVIDENCE_STORE_KEY);

export const evidenceState = createSelector(state, (state1: IListEvidenceState) => state1);
export const evidence = createSelector(state, (state1: IListEvidenceState) => state1.evidence);
export const evidenceQuery = createSelector(state, (state1: IListEvidenceState) => state1.query);
export const evidenceCount = createSelector(state, (state1: IListEvidenceState) => state1.count);
export const isLoading = createSelector(state, (state1: IListEvidenceState) => state1.isLoadingEvidenceList);
export const isSharedWithMeLoading = createSelector(state, (state1: IListEvidenceState) => state1.isLoadingSharedWithMe);
